export const travelQuoteError = {
    groupName: "",
    groupType: "",
    eventName: "",
    noOfTravellers: "",
    destination: "",
    departure: "",
    noOfAdults: "",
    product: "",
    roomTypes: ["", "", ""],
    customRoomTypes: ["", "", ""],
    deviationError: {}
};

export const customQuoteError = {
    itinerarySelection: "",
    individualItineraryMarkupSelection: "",
    selectedConcessions: "",
    selectedPromotions: ""
};
